'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconArrowButtonUp2 = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.437 19L13.711 2.93a2 2 0 0 0-3.422 0L.563 19a2 2 0 0 0 1.711 3.035h19.452A2 2 0 0 0 23.437 19z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M2.331 21.533a1.502 1.502 0 0 1-1.284-2.276l9.724-16.069a1.492 1.492 0 0 1 1.285-.724 1.505 1.505 0 0 1 1.281.723l9.726 16.069a1.502 1.502 0 0 1-1.28 2.276l-19.452.001zm9.725-18.068a.501.501 0 0 0-.429.242L1.903 19.775a.5.5 0 0 0 .428.758h19.45a.501.501 0 0 0 .427-.758L12.482 3.706a.506.506 0 0 0-.426-.241z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M2.236 21.75a1.53 1.53 0 0 1-.738-.201 1.49 1.49 0 0 1-.699-.911 1.49 1.49 0 0 1 .15-1.138l9.759-17.242a1.473 1.473 0 0 1 1.289-.756 1.481 1.481 0 0 1 1.294.76l9.761 17.244c.124.215.193.465.198.719a1.49 1.49 0 0 1-.422 1.068 1.49 1.49 0 0 1-1.053.457H2.236zm.016-1.506l19.51.005-9.763-17.226-9.747 17.221z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconArrowButtonUp2.displayName = 'IconArrowButtonUp2';
exports.default = IconArrowButtonUp2;